<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-n3">
        a) Which of the following will destroy the buffering ability of a 500.0 mL solution that is
        0.650 M in
        <chemical-latex content="CH3COOH" />
        and 0.450 M in
        <chemical-latex content="CH3COONa?" />
      </p>

      <v-radio-group
        v-model="inputs.multipleChoiceAnswer"
        class="ml-6 mb-0"
        :disabled="!allowEditing"
      >
        <v-radio v-for="option in options" :key="option.value" class="my-1" :value="option.value">
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>

      <p class="mb-2">b) I think this because:</p>

      <p class="mb-n2">
        <s-textarea v-model="inputs.explainedResponse" outlined />
      </p>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import StembleLatex from '@/tasks/components/StembleLatex';
import STextarea from '@/common/components/STextarea.vue';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'Question537',
  components: {
    ChemicalLatex,
    STextarea,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        multipleChoiceAnswer: null,
        explainedResponse: null,
      },
      options: [
        {text: 'Adding 0.100 mol $\\ce{HCl}$', value: 'HCl_100mmol'},
        {text: 'Adding 0.100 mol $\\ce{NH3}$', value: 'NH3_100mmol'},
        {text: 'Adding 0.170 mol $\\ce{HNO3}$', value: 'HNO3_170mmol'},
        {text: 'Adding 0.170 mol $\\ce{Ba(OH)2}$', value: 'BaOH2_170mmol'},
      ],
    };
  },
};
</script>
